module.exports = __webpack_public_path__ + "media/images/contest-voted-story@2x-2adca3b3c28d392c40f5e4c3ab08e576.png";